import React from 'react';
import { Box, Text } from 'grommet';
import { MEETS } from './filter-utils';
import { FTSelect } from '../inputs';

export const MeetDescription = ({ value }) => {
  return (
    <>
      {value === 'All' && (
        <Text size='small' color='dark-4'>
          And - Your ad will target users who match all the selected conditions
          together.
        </Text>
      )}
      {value === 'Any' && (
        <Text size='small' color='dark-4'>
          Or - Your ad will target users who match any of the selected
          conditions, separately.
        </Text>
      )}
    </>
  );
};

const Meet = ({ value, setSelectedValue, canEdit = true }) => {
  return (
    <Box direction='row' align='center' gap='xsmall' flex={{ shrink: 0 }}>
      <Text size='small'>Apply</Text>
      <Box width='75px'>
        <FTSelect
          size='small'
          options={MEETS}
          labelKey='label'
          valueKey='value'
          disabled={!canEdit}
          value={MEETS.find(m => m.value === value)}
          onChange={optionValue => {
            setSelectedValue(optionValue.value);
          }}
        />
      </Box>
    </Box>
  );
};

Meet.displayName = 'Meet';

export default Meet;
